import ApiClient from '../../../../shared/ApiCliente';

export interface AssinaturaRequestDto {
  nomeNoCartao: string;
  numeroCartao: string;
  mesExpiracao: string;
  anoExpiracao: string;
  ccv: string;
  cep: string;
  numeroEndereco: string;
  cpf: string;
  plano?: TipoPlanoEnum;
}

export type TipoPlanoEnum =
  | 'BASIC_MENSAL'
  | 'BASIC_ANUAL'
  | 'PLUS_MENSAL'
  | 'PLUS_ANUAL'
  | 'PRO_MENSAL'
  | 'PRO_ANUAL';

export interface AssinaturaResponseDto {
  id: string;
  nomeNoCartao: string;
  numeroCartao: string; // usually masked
  cartaoDeCredito?: {
    finalCartao?: string;
    ultimo4Digitos?: string;
    numeroFinal?: string;
    bandeira?: string;
  };
  mesExpiracao: string;
  anoExpiracao: string;
  plano: string;
  valor: number;
  dataProximaCobranca?: string;
  proximoVencimento?: string;
  status: string;
}

export interface AtualizarPlanoRequestDto {
  novoPlano: TipoPlanoEnum;
}

export interface AssinaturaExpiracaoResponseDto {
  expiration?: number;
  expirationIso?: string;
  plano?: string;
}

export interface AssinaturaPortalResponseDto {
  url: string;
}

export interface CheckoutAssinaturaRequestDto {
  priceId: string;
}

export interface CheckoutAssinaturaResponseDto {
  url: string;
}

export const subscriptionService = {
  criarAssinatura: async (assinaturaRequest: AssinaturaRequestDto): Promise<AssinaturaResponseDto> => {
    try {
      const response = await ApiClient.post<AssinaturaResponseDto>('/assinaturas', assinaturaRequest);
      return response.data;
    } catch (error) {
      console.error('Error creating subscription:', error);
      throw error;
    }
  },

  buscarAssinatura: async (): Promise<AssinaturaResponseDto | null> => {
    try {
      const response = await ApiClient.get<AssinaturaResponseDto>('/assinaturas');
      return response.data;
    } catch (error) {
      if ((error as any).response?.status === 404) {
        return null;
      }
      console.error('Error fetching subscription:', error);
      throw error;
    }
  },

  buscarExpiracaoAssinatura: async (): Promise<AssinaturaExpiracaoResponseDto | null> => {
    try {
      const response = await ApiClient.get<AssinaturaExpiracaoResponseDto>('/assinaturas/expiracao');
      return response.data;
    } catch (error) {
      if ((error as any).response?.status === 404) {
        return null;
      }
      console.error('Error fetching subscription expiration:', error);
      throw error;
    }
  },

  buscarPortalAssinatura: async (): Promise<AssinaturaPortalResponseDto | null> => {
    try {
      const response = await ApiClient.get<AssinaturaPortalResponseDto>('/assinaturas/portal');
      return response.data;
    } catch (error) {
      if ((error as any).response?.status === 404) {
        return null;
      }
      console.error('Error fetching subscription portal URL:', error);
      throw error;
    }
  },

  criarCheckout: async (payload: CheckoutAssinaturaRequestDto): Promise<CheckoutAssinaturaResponseDto> => {
    try {
      const response = await ApiClient.post<CheckoutAssinaturaResponseDto>('/assinaturas/checkout', payload);
      return response.data;
    } catch (error) {
      console.error('Error creating checkout session:', error);
      throw error;
    }
  },

  atualizarCartao: async (assinaturaRequest: AssinaturaRequestDto): Promise<AssinaturaResponseDto> => {
    try {
      const response = await ApiClient.put<AssinaturaResponseDto>('/assinaturas/cartao', assinaturaRequest);
      return response.data;
    } catch (error) {
      console.error('Error updating card:', error);
      throw error;
    }
  },

  atualizarPlano: async (payload: AtualizarPlanoRequestDto): Promise<AssinaturaResponseDto> => {
    try {
      const response = await ApiClient.put<AssinaturaResponseDto>('/assinaturas', payload);
      return response.data;
    } catch (error) {
      console.error('Error updating subscription plan:', error);
      throw error;
    }
  },

  deletarAssinatura: async (): Promise<void> => {
    try {
      await ApiClient.delete('/assinaturas');
    } catch (error) {
      console.error('Error deleting subscription:', error);
      throw error;
    }
  },
};
